import React, {useEffect, useState} from 'react';
import {Button, Drawer, Table} from "antd";
import Pallet from "../../http_request/Model/pallet/Pallet";
import {toast} from "react-toastify";
import DrawerColumn from "./DrawerColumn";
import {useSelector} from "react-redux";

const DrawerTable = ({
                         showEvent,
                         setOpenDrawer,
                         buttonNumber = null,
                         showButton = <Button className='defBtn orangeBtn'> ثبت نشده({buttonNumber})</Button>,
                         title = ' ثبت نشده',
                         filter = {},
                         openDrawer,

                     }) => {
    const [columns] = DrawerColumn(showEvent);
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
     const [dataRows, setDataRows] = useState([]);

    const getAgain = useSelector((state) => state.TableRedux.getAgain);




    const showDrawer = () => {
        setOpen(true);
        setOpenDrawer && setOpenDrawer(true);
    };
    const onClose = () => {
        setOpen(false);
        setOpenDrawer && setOpenDrawer(false);
    };
    useEffect(() => {
     }, [filter])
    useEffect(() => {
        if (openDrawer) {

            setOpen(openDrawer)
        }
    }, [openDrawer])
     useEffect(() => {
        if (open) {


            Pallet.request({
                beforeSend: () => {
                    setLoading(true)
                }, success: (result) => {
                    setDataRows(result.result)
                 }, error: (error) => {
                    toast.error(error.data.message);

                }, final: () => {
                    setLoading(false)
                },
            }).addParams({...filter}).palletList();
        }
    }, [open,getAgain,filter])
    return (


        <>
            <div onClick={showDrawer}>
                {showButton}
            </div>
            <Drawer height='70%'
                title={title}
                placement='bottom'
                closable={false}
                onClose={onClose}
                open={open}
            >

                <Table
                    columns={columns}

                    dataSource={dataRows} loading={loading}
                    pagination={false}/>
            </Drawer>
        </>

    );
};

export default DrawerTable;